import React from 'react'

function Footer() {
      return (
            <div className="w-full text-center p-6 bg-gray-300">
                  <p className="text-lg">Created with blood, sweat and tears of <a className="font-semibold" href="https://github.com/nikvv" target="_blank" rel="noopener noreferrer">@nickovalentino</a></p>
                  <p className="text-lg">Pokemon API provided by:  <a className="font-semibold" href="https://pokeapi.co/">PokeAPI</a></p>
            </div>
      )
}

export default Footer
